// extracted by mini-css-extract-plugin
export var article = "styles-module--article--9701e";
export var articles = "styles-module--articles--3a893";
export var clearButton = "styles-module--clearButton--0d38a";
export var clearButtonSvg = "styles-module--clearButtonSvg--0f409";
export var container = "styles-module--container--a6c94";
export var desktop = "1340px";
export var filterBar = "styles-module--filterBar--486c9";
export var filterButtonsMobile = "styles-module--filterButtonsMobile--c0dda";
export var filterDropdowns = "styles-module--filterDropdowns--eff2f";
export var footer = "styles-module--footer--98286";
export var giant = "2200px";
export var heading = "styles-module--heading--dc5c3";
export var headingText = "styles-module--headingText--57d6c";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var mobileFilter = "styles-module--mobileFilter--ac3f5";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";